import api from './api';

export interface UserPreferences {
  id: number;
  userId: number;
  defaultSectorId: number | null;
  targetMcerlLevel: 'A1' | 'A2' | 'B1' | 'B2' | 'C1' | 'C2';
  enableAiSimplification: boolean;
  theme: 'LIGHT' | 'DARK';
  language: string;
  aiProvider: 'CHATGPT' | 'CLAUDE';
  openaiApiKey: string | null;
  claudeApiKey: string | null;
  openaiModel: string;
  claudeModel: string;
}

export interface UpdatePreferencesRequest {
  defaultSectorId?: number | null;
  targetMcerlLevel?: 'A1' | 'A2' | 'B1' | 'B2' | 'C1' | 'C2';
  enableAiSimplification?: boolean;
  theme?: 'LIGHT' | 'DARK';
  language?: string;
  aiProvider?: 'CHATGPT' | 'CLAUDE';
  openaiApiKey?: string | null;
  claudeApiKey?: string | null;
  openaiModel?: string;
  claudeModel?: string;
}

export const userService = {
  async getPreferences(): Promise<{ preferences: UserPreferences }> {
    const response = await api.get<{ preferences: UserPreferences }>('/user/preferences');
    return response.data;
  },

  async updatePreferences(data: UpdatePreferencesRequest): Promise<{ preferences: UserPreferences }> {
    const response = await api.put<{ preferences: UserPreferences }>('/user/preferences', data);
    return response.data;
  },
};
